"use client";

import React from "react";
import { Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Careers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="careers" className="bg-background py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="max-w-4xl mx-auto bg-card/50 backdrop-blur-sm border-primary/5 shadow-sm overflow-hidden">
            <CardContent className="p-8 md:p-16 flex flex-col items-center text-center space-y-10">
              {}
              <div className="space-y-6 max-w-2xl">
                <blockquote className="article-title text-3xl text-primary leading-tight !italic md:text-4xl lg:text-5xl">“We must believe that we are gifted for something, and that this thing must be attained.”</blockquote>
                <cite className="block text-sm md:text-base text-muted-foreground font-sans tracking-widest uppercase not-italic">M. CURIE – PREMIO NOBEL PER LA FISICA E LA CHIMICA</cite>
              </div>

              {}
              <div className="w-16 h-px bg-ring/60" />

              {}
              <div className="space-y-6 max-w-2xl text-muted-foreground font-sans text-lg leading-relaxed">
                <p className="!text-justify">Nel nostro studio, la curiosità professionale, l’empatia con il cliente e la disponibilità a lavorare in team sono le fondamenta di ogni nostra azione. Siamo alla ricerca di professionisti che condividano la nostra dedizione a tali principi. Offriamo un ambiente di lavoro che valorizza il talento individuale all'interno di una visione collettiva, dove la crescita professionale è sostenuta da una cultura di apprendimento continuo e rispetto reciproco.</p>
                
              </div>

              {}
              <div className="pt-4 flex flex-col items-center gap-4">
                
                <Button asChild size="lg" className="bg-ring hover:bg-ring/90 text-primary-foreground font-medium px-8 py-6 text-lg rounded-full transition-all duration-300 shadow-md hover:shadow-lg">
                  
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}